import React from 'react';
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

function SelexMBExplorerXFP() {
  return (
    <div>
         <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

         <iframe
      src="/SelexMBExplorer/indexxfp.html"
      width="100%"
      height="750px"
      style={{ border: "none" }}
      title="HTML Page"
    />
    </div>
  )
}

export default SelexMBExplorerXFP